import {
  FETCH_BANKS_REQUEST,
  FETCH_BANKS_SUCCESS,
  FETCH_BANKS_FAILURE,
} from 'actionTypes';
import createReducer from './createReducer';

export const initialState = {
  entities: {},
  ids: [],
  isFetching: false,
  isRequestFailed: false,
  isInitialized: false,
};

export const banks = createReducer(initialState, {
  [FETCH_BANKS_REQUEST]: state => ({
    ...state,
    isFetching: true,
    isRequestFailed: false,
  }),

  [FETCH_BANKS_SUCCESS]: (state, action) => ({
    ...state,
    entities: {
      ...state.entities,
      ...action.payload.entities,
    },
    ids: Array.from(new Set([...state.ids, ...action.payload.ids])),
    isFetching: false,
    isInitialized: true,
  }),

  [FETCH_BANKS_FAILURE]: state => ({
    ...state,
    isFetching: false,
    isRequestFailed: true,
    isInitialized: true,
  }),
});

export default banks;
